export const darkMono = {
    appBgPrimary: '#000000',
    appBgSecondary: '#16181a',
    textPrimary: '#ffffff',
    textSecondary: '#b3b3b3',
    border: '#2a2d2f',
    shadow: 'rgba(0, 0, 0, 0.5)',
    gameUser: '#0f1a2b',
    gameAssistant: '#1a0f1f',
    gameNarrator: '#20180c',
    gameSystem: '#0f1a12',
};
export const lightMono = {
    appBgPrimary: '#ffffff',
    appBgSecondary: '#f7f8fa',
    textPrimary: '#111111',
    textSecondary: '#555555',
    border: '#e5e7eb',
    shadow: 'rgba(0, 0, 0, 0.06)',
    gameUser: '#eef2ff',
    gameAssistant: '#fef3c7',
    gameNarrator: '#f1f5f9',
    gameSystem: '#f0f9ff',
};
export function applyVisualStyle(tokens) {
    const root = document.documentElement;
    root.style.setProperty('--app-bg-primary', tokens.appBgPrimary);
    root.style.setProperty('--app-bg-secondary', tokens.appBgSecondary);
    root.style.setProperty('--app-text-primary', tokens.textPrimary);
    root.style.setProperty('--app-text-secondary', tokens.textSecondary);
    root.style.setProperty('--app-border', tokens.border);
    root.style.setProperty('--app-shadow', tokens.shadow);
    if (tokens.gameUser)
        root.style.setProperty('--game-message-user', tokens.gameUser);
    if (tokens.gameAssistant)
        root.style.setProperty('--game-message-assistant', tokens.gameAssistant);
    if (tokens.gameNarrator)
        root.style.setProperty('--game-message-narrator', tokens.gameNarrator);
    if (tokens.gameSystem)
        root.style.setProperty('--game-message-system', tokens.gameSystem);
}
